import React from "react";
import PropTypes from "prop-types";
import { Table } from "react-bootstrap";
import styled, { css } from "styled-components";

const Container = styled.div`
  min-width: 100%;
  max-width: 100%;
  padding: 25px 32px 56px;
  margin-bottom: 33px;
  background: #ffffff;
  box-shadow: 0px 3px 25px rgba(168, 168, 168, 0.3);

  .table-responsive {
    max-height: 500px;

    .table {
      margin-bottom: 0;
    }
  }
`;
const Title = styled.h1`
  font-weight: bold;
  font-size: 18px;
  line-height: 47px;
  color: #7b848d;
  ${({ theme: { mobile } }) =>
    mobile &&
    css`
      font-size: 16px;
    `}
`;
const TableHeader = styled.thead`
  height: 42px;
`;
const TableHeaderRow = styled.tr`
  vertical-align: middle;
  background-color: #ffffff;
  position: sticky;
  top: 0;
`;
const TableHeaderCell = styled.th`
  text-align: center;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 15px;
  color: #7b848d;
  white-space: nowrap;
  ${({ mwidth }) => (mwidth ? `max-width: ${mwidth}px !important` : "")}
`;
const TableHeaderCellSticky = styled(TableHeaderCell)`
  position: sticky;
  top: 0;
  left: 0;
  border-bottom: none !important;
  background-color: #ecedf1 !important;
`;
const TableHeaderCellLeft = styled(TableHeaderCell)`
  text-align: left;
`;
const TableBody = styled.tbody`
  border: none !important;
`;
const TableBodyRow = styled.tr`
  vertical-align: middle;
  border-top: none;
  border-bottom: 1px solid #ecedf1;
  height: 40px;
  background-color: ${({ index }) => (index % 2 === 0 ? "#FAFAFF;" : "#FFFFFF")};

  &:hover {
    background-color: #eaeaea;
  }
`;
const TableBodyCell = styled.td`
  text-align: center;
  font-style: normal;
  font-size: 12px;
  white-space: nowrap;
  color: ${({ color }) => color || "#394149"};
`;
const TableBodyCellSticky = styled(TableBodyCell)`
  position: sticky;
  top: 42px;
  left: 0;
  background-color: #ecedf1 !important;
`;
const TableBodyCellLeft = styled(TableBodyCell)`
  text-align: left;
`;

const EmptyMessage = styled.div`
  color: #7b848d;
  font-weight: bold;
  text-align: center;
`;

function TableRow({ index, ...props }) {
  return (
    <TableBodyRow index={index}>
      <TableBodyCellSticky index={index}>{index + 1}</TableBodyCellSticky>
      <TableBodyCellLeft>{props.markName}</TableBodyCellLeft>
      <TableBodyCellLeft>{props.numberAssigned}</TableBodyCellLeft>
      <TableBodyCellLeft>{props.owner.firstName}</TableBodyCellLeft>
      <TableBodyCellLeft>{props.owner.middleName}</TableBodyCellLeft>
      <TableBodyCellLeft>{props.owner.lastName}</TableBodyCellLeft>
      <TableBodyCellLeft>{props.owner.suffixName}</TableBodyCellLeft>
      <TableBodyCellLeft>{props.owner.phone}</TableBodyCellLeft>
      <TableBodyCellLeft>{props.owner.email}</TableBodyCellLeft>
      <TableBodyCellLeft>{props.owner.countryOfCitizenship}</TableBodyCellLeft>
      <TableBodyCellLeft>{props.owner.address.address1}</TableBodyCellLeft>
      <TableBodyCellLeft>{props.owner.address.city}</TableBodyCellLeft>
      <TableBodyCellLeft>{props.owner.address.state}</TableBodyCellLeft>
      <TableBodyCellLeft>{props.owner.address.zip}</TableBodyCellLeft>
      <TableBodyCellLeft>{props.owner.address.county}</TableBodyCellLeft>
      <TableBodyCellLeft>{props.classification}</TableBodyCellLeft>
      <TableBodyCellLeft>{props.service}</TableBodyCellLeft>
      <TableBodyCellLeft>{props.description}</TableBodyCellLeft>
      <TableBodyCellLeft>{props.renewalDate}</TableBodyCellLeft>
    </TableBodyRow>
  );
}

TableRow.propTypes = {
  index: PropTypes.number,
  markName: PropTypes.string,
  numberAssigned: PropTypes.string,
  owner: PropTypes.object,
  classification: PropTypes.string,
  service: PropTypes.string,
  description: PropTypes.string,
  renewalDate: PropTypes.string,
};

function StateSearchResults({ stateSearchResults }) {
  if (!stateSearchResults) return null;

  return (
    <Container>
      <Title>State Search Results</Title>
      {stateSearchResults.length ? (
        <Table responsive>
          <TableHeader>
            <TableHeaderRow>
              <TableHeaderCellSticky>#</TableHeaderCellSticky>
              <TableHeaderCellLeft>MARK NAME</TableHeaderCellLeft>
              <TableHeaderCellLeft>NUMBER ASSIGNED</TableHeaderCellLeft>
              <TableHeaderCellLeft>FIRST NAME</TableHeaderCellLeft>
              <TableHeaderCellLeft>MIDDLE NAME</TableHeaderCellLeft>
              <TableHeaderCellLeft>LAST NAME</TableHeaderCellLeft>
              <TableHeaderCellLeft>SUFFIX NAME</TableHeaderCellLeft>
              <TableHeaderCellLeft>PHONE</TableHeaderCellLeft>
              <TableHeaderCellLeft>EMAIL</TableHeaderCellLeft>
              <TableHeaderCellLeft>COUNTRY OF CITIZENSHIP</TableHeaderCellLeft>
              <TableHeaderCellLeft>ADDRESS</TableHeaderCellLeft>
              <TableHeaderCellLeft>CITY</TableHeaderCellLeft>
              <TableHeaderCellLeft>STATE</TableHeaderCellLeft>
              <TableHeaderCellLeft>ZIP</TableHeaderCellLeft>
              <TableHeaderCellLeft>COUNTY</TableHeaderCellLeft>
              <TableHeaderCellLeft>CLASSIFICATION</TableHeaderCellLeft>
              <TableHeaderCellLeft>SERVICE</TableHeaderCellLeft>
              <TableHeaderCellLeft>DESCRIPTION</TableHeaderCellLeft>
              <TableHeaderCellLeft>RENEWAL DATE</TableHeaderCellLeft>
            </TableHeaderRow>
          </TableHeader>
          <TableBody>
            {stateSearchResults.map((stateSearchInfo, idx) => (
              <TableRow key={idx} index={idx} {...stateSearchInfo} />
            ))}
          </TableBody>
        </Table>
      ) : (
        <EmptyMessage>No conflicting State search results found</EmptyMessage>
      )}
    </Container>
  );
}

StateSearchResults.propTypes = {
  stateSearchResults: PropTypes.arrayOf(PropTypes.object),
};

export default StateSearchResults;
